module.exports = __webpack_public_path__ + "static/img/rank_avatar_frame_starlight.e500facd.png";